import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';

import Page from './containers/Page/Page';
import Calculate from './containers/Calculate/Calculate';

import store from './store';

import './static/styles/index.scss';

ReactDOM.render(
  <AppContainer>
    <Provider store={ store }>
      <Page>
        <Calculate />
      </Page>
    </Provider>
  </AppContainer>,
  document.getElementById('root')
);

// Hot Module Replacement API
// if (module.hot) {
//   module.hot.accept('./routes', () => {
//     ReactDOM.render(
//       <AppContainer>
//         <Provider store={ store }>
//           567
//         </Provider>
//       </AppContainer>,
//       document.getElementById('root')
//     );
//   });
// }

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js